import classnames from "classnames";
import React, { useEffect, useRef, useState } from "react";

import "./HideableSplashScreen.scss";
import SplashScreen from "./SplashScreen";

type Props = {
  hide?: boolean | null | undefined;
};

const HIDE_SPLASHSCREEN_DELAY = 1000;

export default function HideableSplashScreen({ hide }: Props) {
  const [doneHiding, setDoneHiding] = useState(false);

  const _timeout = useRef<NodeJS.Timeout>();

  useEffect(() => {
    if (hide) {
      _timeout.current = setTimeout(
        () => setDoneHiding(true),
        HIDE_SPLASHSCREEN_DELAY
      );
    }

    return () => clearTimeout(_timeout.current!);
  }, [hide]);

  return doneHiding ? null : (
    <SplashScreen
      className={classnames({
        "HideableSplashScreen--hide": hide
      })}
    />
  );
}
